export const paths = {
  // Sections
  ips: 'cdaReader',
  alerts: 'alerts',
  dailyMonitoring: 'dailyMonitoring',
  somatometrics: 'somatometrics',
  medicalProblems: 'medicalProblems',
  medicalHistorySection: 'medicalHistory',
  pregnancy: 'pregnancy',
  gynaecology: 'gynaecology',
  hysteroscopy: 'hysteroscopy',
  medicationSummary: 'medicationSummary',
  socialHistory: 'socialHistory',
  laboratory: 'laboratory',
  imaging: 'imaging',
  healthCarePlan: 'carePlan',
  travelHistory: 'travelHistory',
  episodeOfCare: 'episodeOfCare',
  pilotStudy: 'pilotStudy',
  tracheostomy: 'tracheostomy',
  etiology: 'etiology',
  complication: 'complication',
  comorbidity: 'comorbidity',
  preciousAi: 'preciousAi',
  patientCharacteristics: 'patientCharacteristics',
  initialAssessments: 'initialAssessments',
  selfReport: 'selfReport',

  // Sub-items
  vitalSigns: 'vitalSigns',
  arterialBloodGas: 'arterialBloodGas',
  glasgow: 'glasgow',
  glucose: 'glucose',
  nutritionIntake: 'nutritionIntake',
  neck: 'neckSize',
  weight: 'weight',
  allergies: 'allergies',
  medicalAlert: 'medicalAlert',
  vaccinations: 'vaccinations',
  resolvedProblems: 'resolvedProblems',
  medicalHistory: 'medical',
  currentProblems: 'currentProblems',
  devicesAndImplants: 'deviceAndImplants',
  procedures: 'procedures',
  currentMedicines: 'medicines',
  pastMedicines: 'pastMedicines',

  // socialHistoryObservations: 'socialHistoryObservations',
  // socialHistoryQuestionnaire: 'socialHistoryQuestionnaire',

  laboratoryFiles: 'laboratoryFiles',
  laboratoryResults: 'laboratoryResults',

  imagingFiles: 'imagingFiles',
  multipleSclerosisSegmentation: 'multipleSclerosisSegmentation',
  preciousMedSamSegmentation: 'preciousMedSamSegmentation',

  ctParameters: 'ctParameters',
  tubeCharacteristics: 'tubeCharacteristics',
  capnography: 'capnography',
  hysteroscopyFiles: 'hysteroscopyFiles',

  socialQuestionnaireAmen: 'socialQuestionnaireAmen',
  supportingDocumentsAmen: 'supportingDocumentsAmen',
  fastProtocolQuestionnaireMediterrenean: 'fastProtocolQuestionnaireMediterrenean',
  strokeScoreQuestionnaireMediterrenean: 'strokeScoreQuestionnaireMediterrenean',

  // Workspace
  workspace: {
    myPatients: 'myPatients',
    incomingReferrals: 'incomingReferrals',
    outgoingReferrals: 'outgoingReferrals',
  },
};
